import { render, staticRenderFns } from "./account-edit-dialog.vue?vue&type=template&id=065116f8&scoped=true&"
import script from "./account-edit-dialog.vue?vue&type=script&lang=js&"
export * from "./account-edit-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065116f8",
  null
  
)

export default component.exports